module.exports = __webpack_public_path__ + "static/play-96d9413431b23959f2e2633b38fa7574.png";